// semeia-disable-reexport
export function computeMedian(arr) {
  // Sort the array in ascending order
  arr.sort((a, b) => a - b);

  const mid = Math.floor(arr.length / 2);

  // If the array length is odd, return the middle element
  if (arr.length % 2 !== 0) return arr[mid];

  // If the array length is even, return the average of the two middle elements
  return (arr[mid - 1] + arr[mid]) / 2;
}
